import Layout from "@/components/Layout";
import { Books, Star } from "@phosphor-icons/react";

const SHELF = [
  {
    pillar: "Strategy",
    chip: "bg-indigo-50 text-indigo-700 border border-indigo-200",
    books: [
      { title: "Good Strategy / Bad Strategy", author: "Richard Rumelt", note: "The clearest articulation of what a real strategy is — a diagnosis, a guiding policy, coherent action — and why most 'strategies' are wish lists." },
      { title: "Playing to Win", author: "A.G. Lafley & Roger Martin", note: "A cascade of five choices that turns strategy from aspiration into where-to-play / how-to-win decisions." },
      { title: "Thinking in Bets", author: "Annie Duke", note: "Decision quality under uncertainty — separating the quality of a decision from the luck of its outcome." },
    ],
  },
  {
    pillar: "Operations",
    chip: "bg-amber-50 text-amber-700 border border-amber-200",
    books: [
      { title: "The Goal", author: "Eliyahu M. Goldratt", note: "The novel that taught a generation the Theory of Constraints — find the bottleneck, everything else is noise." },
      { title: "The Checklist Manifesto", author: "Atul Gawande", note: "Why disciplined, simple checklists outperform expertise in complex, high-stakes execution." },
      { title: "High Output Management", author: "Andrew S. Grove", note: "The operating manual for managerial leverage, output metrics and run-the-business cadence." },
      { title: "Execution: The Discipline of Getting Things Done", author: "Larry Bossidy & Ram Charan", note: "Why execution is a discipline in its own right — linking people, strategy and operations so plans actually land." },
    ],
  },
  {
    pillar: "People",
    chip: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    books: [
      { title: "The Coaching Habit", author: "Michael Bungay Stanier", note: "Seven questions that replace advice-giving with genuine coaching — say less, ask more." },
      { title: "Radical Candor", author: "Kim Scott", note: "Care personally, challenge directly — the simple two-axis model for feedback that lands." },
      { title: "Turn the Ship Around!", author: "L. David Marquet", note: "A submarine captain's account of moving from leader-follower to leader-leader through intent-based authority." },
      { title: "Fierce Conversations", author: "Susan Scott", note: "How to make each conversation count — interrogate reality, provoke learning and tackle the tough issues head-on." },
    ],
  },
];

export default function ReadingList() {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto w-full py-10 px-6 lg:px-10">
        <div className="flex items-center gap-2 text-slate-500">
          <Books size={18} weight="duotone" />
          <p className="text-xs font-semibold tracking-[0.12em] uppercase">Reading List</p>
        </div>
        <h1 className="mt-1 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">The Operator's Bookshelf</h1>
        <p className="mt-2 text-slate-500 max-w-2xl">A curated shelf behind the MODUS toolkit — the thinking that shaped each pillar.</p>

        <div className="mt-8 space-y-8" data-testid="reading-list">
          {SHELF.map((group) => (
            <section key={group.pillar} data-testid={`shelf-${group.pillar.toLowerCase()}`}>
              <span className={`px-2 py-0.5 rounded-sm text-[10px] font-semibold uppercase tracking-wide ${group.chip}`}>{group.pillar}</span>
              <div className="mt-3 grid grid-cols-1 lg:grid-cols-3 gap-4">
                {group.books.map((b) => (
                  <div key={b.title} className="bg-white border border-slate-200 rounded-sm p-5 shadow-sm">
                    <div className="flex items-center gap-1 text-amber-400 mb-2">
                      {[...Array(3)].map((_, i) => <Star key={i} size={13} weight="fill" />)}
                    </div>
                    <h3 className="text-base font-semibold text-slate-900 leading-snug">{b.title}</h3>
                    <p className="font-mono text-xs text-slate-400 mt-0.5">{b.author}</p>
                    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{b.note}</p>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
}
